import React, { PropsWithChildren } from "react";

type Props = {};

export const NewContent = (props: PropsWithChildren<Props>) => {
    const { children } = props;
    return <div className="newContent">{children}</div>;
};
